const baseRoute = 'qse-reports/:moduleBridgeHex/:subModuleBridgeHex/:plantHex/';
export const routes = {
  // user_module_qseReports_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //     subModuleBridgeHex: undefined,
  //     plantHex: undefined,
  //   },
  // },
  user_module_qseReports_home: {
    path: `${baseRoute}home`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_qseReports_quality: {
    path: `${baseRoute}quality`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_qseReports_safety: {
    path: `${baseRoute}safety`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
  user_module_qseReports_environment: {
    path: `${baseRoute}environment`,
    parameters: {
      moduleBridgeHex: undefined,
      subModuleBridgeHex: undefined,
      plantHex: undefined,
    },
  },
};
